const comMeta = { lang: 'zh' }

const productService = [
  {
    path: '/product-service',
    name: `product-service`,
    component: () => import('@/views/productService/index'),
    meta: {
      ...comMeta,
      title: '产品服务',
      metaInfo: {
        title: '华盟·税纪云 _产品服务'
      }
    }
  },
  {
    path: '/product-service/details',
    name: 'productServiceDetails',
    component: () => import('@/views/productService/productServiceDetails'),
    meta: {
      ...comMeta,
      title: '产品服务',
      nav: 'product-service'
    }
  },
  {
    path: '/rddExpenseTax',
    name: `rddExpenseTax`,
    component: () => import('@/views/productService/components/rdtc/index'),
    meta: {
      ...comMeta,
      title: '研发费用税务优惠管理系统'
    }
  },
  {
    path: '/riskManagement',
    name: 'riskManagement',
    component: () => import('@/views/productService/components/riskManage/index'),
    meta: {
      ...comMeta,
      title: '风险管理'
    }
  },
  // {
  //   path: '/taxDeclaration',
  //   name: `taxDeclaration`,
  //   component: () => import('@/views/productService/components/taxDeclaration'),
  //   meta: {
  //     ...comMeta,
  //     title: '一键申报'
  //   }
  // },
  {
    path: '/chartTexeraJc',
    name: `chartTexeraJc`,
    component: () => import('@/views/productService/components/chartTexeraJc'),
    meta: {
      ...comMeta,
      title: '精财一言'
    }
  },
]

export default productService



// WEBPACK FOOTER //
// ./src/router/modules/product-service.js